import { getPricingVehicleListRequest } from "../../data/pricingVehicleApi";

function getPayloadData(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  return [];
}

export async function getPricingVehicleListUseCase() {
  const vehicles = getPayloadData(await getPricingVehicleListRequest());
  return [...vehicles].sort((a, b) => a.order - b.order);
}
